module.exports = __webpack_public_path__ + "static/media/nb.701e9778.png";